import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import EditableNumberCell from './editable-number-cell';
import { ItemQuantityCell } from './item-quantity';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { RowPropType } from '../../../../../prop-types/react-table';
import messages from '../messages';

import style from '../style.module.less';

const ItemReturnQuantityColumnId = 'returnQuantity';

const itemReturnQuantityDataBuilder = (item) => {
  return item[ItemReturnQuantityColumnId];
};

const ReturnQuantityCell = ({ value, row, updateRowProperty }) => {
  const { checked } = row.getToggleRowSelectedProps?.() || {};

  const onChange = useCallback(
    (newValue) => {
      updateRowProperty(row.id, ItemReturnQuantityColumnId, newValue);
    },
    [row.id, updateRowProperty],
  );

  const max = row.values.quantity;

  return checked ? (
    <EditableNumberCell max={max} min={0} onChange={onChange} value={value} />
  ) : (
    <ItemQuantityCell row={row} value={value} />
  );
};

ReturnQuantityCell.propTypes = {
  value: PropTypes.number,
  row: RowPropType.isRequired,
  updateRowProperty: PropTypes.func.isRequired,
};

const createItemReturnQuantityColumnDefinition = createColumnDefinitionBuilder({
  Header: <FormattedMessage {...messages.returnQuantity} />,
  accessor: ItemReturnQuantityColumnId,
  Cell: ReturnQuantityCell,
  width: 1,
  className: style['justify-center'],
});

export { ItemReturnQuantityColumnId, itemReturnQuantityDataBuilder, createItemReturnQuantityColumnDefinition };
